import React from 'react';

export default function Donate() {
  return (
    <div className='px-8 lg:px-24'>Donate</div>
  )
}
